import { render } from "./BaseCalculator.vue?vue&type=template&id=12b2dbbc&scoped=true"
import script from "./BaseCalculator.vue?vue&type=script&lang=js"
export * from "./BaseCalculator.vue?vue&type=script&lang=js"

import "./BaseCalculator.vue?vue&type=style&index=0&id=12b2dbbc&scoped=true&lang=css"

import exportComponent from "/home/ysm/workspace/webtool/www-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12b2dbbc"]])

export default __exports__